import { useSortable } from "@dnd-kit/sortable";

import config from "@/config";
import Text from "@/shared-components/text/components/Text";
import { getArtworkArtistDisplayName } from "@/utils/artworkArtists";

import "./styles/ArtworkRow.css";

export default function ArtworkRow({ style, item, deleteItem, isActive }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useSortable({ id: item._id });

  const itemStyle = {
    ...style,
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
      : undefined,
    opacity: isDragging ? 0 : 1,
    backgroundColor: isActive ? "#0005" : null,
  };
  const image = item.artwork_media.artwork_main_picture.image_id;
  const artistName = getArtworkArtistDisplayName(item);

  const onRemove = () => {
    const res = confirm(
      "Are you sure to remove this artwork from the collection?"
    );
    if (res) deleteItem();
  };

  return (
    <div
      ref={setNodeRef}
      style={itemStyle}
      className="element-non-selectable"
      {...attributes}
      {...listeners}
    >
      <div
        className={`customize-existing-carousel__artwork-row ${
          isActive ? "drag-overlay" : ""
        }`}
      >
        <div
          className="customize-existing-carousel__artwork-add"
          onClick={onRemove}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <circle
              cx="10"
              cy="10"
              r="9.25"
              stroke="#FFBA00"
              strokeWidth="1.5"
            />
            <path
              d="M6 10H14"
              stroke="#FFBA00"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <img
          src={`${config.app.imageServiceDomain}/${image}/w=200`}
          srcSet={`${config.app.imageServiceDomain}/${image}/w=200 200w,
                        ${config.app.imageServiceDomain}/${image}/w=400 400w,
                        ${config.app.imageServiceDomain}/${image}/w=600 600w,
                        ${config.app.imageServiceDomain}/${image}/w=800 800w,
                        ${config.app.imageServiceDomain}/${image}/w=1000 1000w,
                        ${config.app.imageServiceDomain}/${image}/w=1200 1200w,
                        ${config.app.imageServiceDomain}/${image}/w=1400 1400w,
                        ${config.app.imageServiceDomain}/${image}/w=1600 1600w,
                        ${config.app.imageServiceDomain}/${image}/w=1800 1800w,
                        ${config.app.imageServiceDomain}/${image}/w=2000 2000w,
                        ${config.app.imageServiceDomain}/${image}/w=2200 2200w`}
          alt="artwork main preview"
          className="customize-existing-carousel__artwork-img"
        />
        <div className="customize-existing-carousel__artwork-text">
          <Text paragraph className="font-size-small">
            {item.artwork_about.artwork_title}
          </Text>
          <Text paragraph className="font-size-small">
            by {artistName}
          </Text>
        </div>
        <div className="customize-existing-carousel__artwork-move">
          <svg
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L12.2347 1"
              stroke="#9B9DAF"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M1 6L12.2347 6"
              stroke="#9B9DAF"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M1 11L12.2347 11"
              stroke="#9B9DAF"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
